import React, { lazy, Suspense } from "react";
import { ISchemaFormProps } from "./SchemaForm";
import { registerExtensionFormComponent } from "./SchemaExtensions";

const SchemaFormMonacoEdit = lazy(() => import("./SchemaFormMonacoEdit"));

export default function LazySchemaFormMonacoEdit(props: ISchemaFormProps) {
    return (
        <Suspense fallback={<div><i className="fa-regular fa-spinner fa-spin"></i></div>}>
            <SchemaFormMonacoEdit {...props}/>
        </Suspense>
    );
};

registerExtensionFormComponent("monacoedit", LazySchemaFormMonacoEdit);
